import moment from 'moment-timezone';
import { AppConfig } from 'AppSrc/core/config/app-config';
import {
  MOBILE,
  FIXED,
} from 'AppSrc/core/components/forms/value-dependency-constants';

const DEFAULT_TIMEZONE = AppConfig.timezones.default;

// take a calendar date in a specific timezone, and convert it to a calendar date at midnight in the local timezone
// EG 2020-01-01T10:00+7 => 2020-01-01T00:00
const dateToMidnightInLocalTZ = (date, originalTz = DEFAULT_TIMEZONE) => {
  if (!date) { return null; }
  const calendarDayString = moment.tz(date, originalTz).format('YYYY-MM-DD');
  return moment(calendarDayString).toDate();
};

// take a calendar date in a specific timezone, and convert it to a calendar date at midnight in the local timezone
// EG 2020-01-01T10:00+7 => 2020-01-01T00:00
const dateToMidnightInSpecificTZ = (date, timezone = DEFAULT_TIMEZONE) => {
  if (!date) { return null; }
  const calendarDayString = moment(date).format('YYYY-MM-DD');
  return moment.tz(calendarDayString, timezone).toDate();
};

const getTimezoneForNetwork = (network) => {
  const timezone = AppConfig.timezones[network];
  // if timezone not specified, return default
  return timezone || DEFAULT_TIMEZONE;
};

const nowInDefaultTZ = () => moment().tz(DEFAULT_TIMEZONE);

const dateToDefaultTz = (date) => {
  if (!date) return null;
  return moment(date).tz(DEFAULT_TIMEZONE);
};

const nowInNetworkTZ = (network) => {
  const knownNetworks = [
    MOBILE,
    FIXED,
  ];
  if (!knownNetworks.includes(network)) {
    console.warning(`Requesting nowInNetworkTZ does not recognise netowrk: ${network}. The time you get back may be wrong!`);
  }
  return moment().tz(getTimezoneForNetwork(network));
};

export {
  dateToMidnightInLocalTZ,
  dateToMidnightInSpecificTZ,
  getTimezoneForNetwork,
  nowInDefaultTZ,
  nowInNetworkTZ,
  dateToDefaultTz,
  DEFAULT_TIMEZONE,
};
